import { Stack, StackProps } from '@mui/material'

export type FieldsetProps = StackProps

const DEFAULT_SPACING = 2

export function Fieldset(props: FieldsetProps) {
  return <Stack component="fieldset" padding={0} border={0} spacing={DEFAULT_SPACING} {...props} />
}
